import { TourOptionParticipantDto } from '@/features/dashboard/tours/types/dashboard/dto/TourOptionParticipantDto.ts';

/** Jeden zaznaczony warunek: konkretny wariant konkretnej opcji. */
export interface OptionFilter {
  optionId: string;
  variantId: string;
}

export const isOptionFilterSelected = (
  filters: OptionFilter[],
  optionId: string,
  variantId: string,
): boolean =>
  filters.some(
    (filter) => filter.optionId === optionId && filter.variantId === variantId,
  );

export const toggleOptionFilter = (
  filters: OptionFilter[],
  optionId: string,
  variantId: string,
): OptionFilter[] =>
  isOptionFilterSelected(filters, optionId, variantId)
    ? filters.filter(
        (filter) =>
          !(filter.optionId === optionId && filter.variantId === variantId),
      )
    : [...filters, { optionId, variantId }];

/**
 * Warunki łączą się przez „i”: uczestnik musi mieć **każdy** zaznaczony
 * wariant. Opcja bywa wielokrotnego wyboru, więc wartość w `selectedOptions`
 * to lista, a nie pojedynczy wariant.
 */
export const matchesOptionFilters = (
  participant: TourOptionParticipantDto,
  filters: OptionFilter[],
): boolean =>
  filters.every((filter) =>
    participant.selectedOptions[filter.optionId]?.includes(filter.variantId),
  );

export const filterParticipants = (
  participants: TourOptionParticipantDto[],
  filters: OptionFilter[],
): TourOptionParticipantDto[] =>
  participants.filter((participant) =>
    matchesOptionFilters(participant, filters),
  );
